<template>
  <div class="building-browse-manage-container animated fadeInRight">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('buildingBrowseManage.search.title') }}</span>
        <el-button type="text" style="float: right; padding: 3px 0" @click="_moreCondition">
          {{ buildingBrowseManageInfo.moreCondition ? $t('common.hide') : $t('common.more') }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="buildingBrowseManageInfo.conditions.buildingName"
            :placeholder="$t('buildingBrowseManage.search.buildingName')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="buildingBrowseManageInfo.conditions.userName"
            :placeholder="$t('buildingBrowseManage.search.userName')" clearable />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="_queryBuildingBrowseMethod">
            <i class="el-icon-search"></i>
            {{ $t('common.search') }}
          </el-button>
          <el-button @click="_resetBuildingBrowseMethod">
            <i class="el-icon-refresh"></i>
            {{ $t('common.reset') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top:20px">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('buildingBrowseManage.list.title') }}</span>
      </div>
      <el-table :data="buildingBrowseManageInfo.browses" border style="width: 100%">
        <el-table-column prop="id" :label="$t('buildingBrowseManage.table.id')" align="center" />
        <el-table-column prop="buildingName" :label="$t('buildingBrowseManage.table.buildingName')" align="center" />
        <el-table-column prop="userName" :label="$t('buildingBrowseManage.table.userName')" align="center" />
        <el-table-column prop="userTel" :label="$t('buildingBrowseManage.table.userTel')" align="center" />
        <el-table-column prop="createTime" :label="$t('buildingBrowseManage.table.createTime')" align="center" />
        <!--<el-table-column prop="statusCd" :label="$t('buildingBrowseManage.table.statusCd')" align="center" />-->
        <!--<el-table-column :label="$t('common.operation')" align="center" width="200">-->
        <!--  <template slot-scope="scope">-->
        <!--    <el-button size="mini" @click="_viewBuildingBrowseModel(scope.row)">-->
        <!--      {{ $t('common.view') }}-->
        <!--    </el-button>-->
        <!--    <el-button size="mini" type="danger" @click="_openDeleteBuildingBrowseModel(scope.row)">-->
        <!--      {{ $t('common.delete') }}-->
        <!--    </el-button>-->
        <!--  </template>-->
        <!--</el-table-column>-->
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" style="margin-top:20px;text-align:right" />
    </el-card>

    <view-building-browse ref="viewBuildingBrowse" />
    <delete-building-browse ref="deleteBuildingBrowse" @success="handleSuccess" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listBuildingBrowses } from '@/api/oa/buildingBrowseManageApi'
import ViewBuildingBrowse from '@/components/oa/viewBuildingBrowseView'
import DeleteBuildingBrowse from '@/components/oa/deleteBuildingBrowse'

export default {
  name: 'BuildingBrowseManageList',
  components: {
    ViewBuildingBrowse,
    DeleteBuildingBrowse
  },
  data() {
    return {
      buildingBrowseManageInfo: {
        browses: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          buildingName: '',
          userName: '',
          page: 1,
          row: 10,
          communityId: ''
        }
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.buildingBrowseManageInfo.conditions.communityId = this.communityId
    this._listBuildingBrowses()
  },
  methods: {
    async _listBuildingBrowses() {
      try {
        const params = {
          ...this.buildingBrowseManageInfo.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await listBuildingBrowses(params)
        this.buildingBrowseManageInfo.browses = data
        this.page.total = total
      } catch (error) {
        console.error('获取房产浏览记录列表失败:', error)
      }
    },
    _viewBuildingBrowseModel(row) {
      this.$refs.viewBuildingBrowse.open(row)
    },
    _openDeleteBuildingBrowseModel(row) {
      this.$refs.deleteBuildingBrowse.open(row)
    },
    _queryBuildingBrowseMethod() {
      this.page.current = 1
      this._listBuildingBrowses()
    },
    _resetBuildingBrowseMethod() {
      this.buildingBrowseManageInfo.conditions = {
        buildingName: '',
        userName: '',
        page: 1,
        row: 10,
        communityId: this.communityId
      }
      this._listBuildingBrowseMethod()
    },
    _moreCondition() {
      this.buildingBrowseManageInfo.moreCondition = !this.buildingBrowseManageInfo.moreCondition
    },
    handleSuccess() {
      this._listBuildingBrowses()
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listBuildingBrowses()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listBuildingBrowses()
    }
  }
}
</script>

<style lang="scss" scoped>
.building-browse-manage-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .no_display {
    display: none;
  }
}
</style>